import ScoreboardRow from "./ScoreboardRow";

export default ScoreboardRow;
